module.exports = __webpack_public_path__ + "img/logo15.23f6a16d.jpg";